class ImperiaPdpGallery extends HTMLElement {
  connectedCallback() {
    this.variantSelect = this.querySelector('[data-variant-select]');

    this.variantSelect?.addEventListener('change', this.handleVariantChange);
  }

  disconnectedCallback() {
    this.variantSelect?.removeEventListener('change', this.handleVariantChange);
  }

  handleVariantChange = (event) => {
    const option = event.currentTarget.selectedOptions[0];
    const available = option?.dataset.available === 'true';
    const price = this.querySelector('[data-product-price]');
    const availability = this.querySelector('[data-product-availability]');
    const compare = this.querySelector('[data-product-compare]');
    const promotion = this.querySelector('[data-product-promotion]');
    const discount = this.querySelector('[data-product-discount]');
    const savings = this.querySelector('[data-product-savings]');
    const button = this.querySelector('[ref="addToCartButton"]');
    const buttonText = button?.querySelector('.add-to-cart-text__content');

    if (price && option?.dataset.price) price.textContent = option.dataset.price;
    if (availability) availability.textContent = available ? 'DISPONIBLE ONLINE' : 'AGOTADO';
    if (compare) { compare.textContent = option?.dataset.compare || ''; compare.hidden = !option?.dataset.compare; }
    if (promotion) promotion.hidden = !option?.dataset.discount;
    if (discount) discount.textContent = option?.dataset.discount ? option.dataset.discount + '% OFF' : '';
    if (savings) savings.textContent = option?.dataset.savings || '';
    if (button) button.disabled = !available;
    if (buttonText) buttonText.textContent = available ? 'AGREGAR AL CARRITO' : 'AGOTADO';
  };
}

if (!customElements.get('imperia-pdp-gallery')) {
  customElements.define('imperia-pdp-gallery', ImperiaPdpGallery);
}
